import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import { select } from '@swf/core/store';
import type { PrizeDetail } from '@swf/core/types/CasinoRaces';
import { PrizeType } from '@swf/core/types/CasinoRaces';

import {
  TXTWCL_Bonuses_may_not_be_withdrawnX__ELL,
  TXTWCL_Carry_an_expiry_date_and_all_s_ELL,
  TXTWCL_Carry_an_expiry_date_and_all_s_ELL_1,
  TXTWCL_Carry_an_expiry_date_and_must__ELL,
  TXTWCL_Credited_Free_Spins_will_carry_ELL,
  TXTWCL_Is_credited_to_your_Stars_Acco_ELL,
  TXTWCL_What_is_a_Cash_BonusX_How_can__ELL,
  TXTWCL_What_is_a_Free_Spins_BonusX_Ho_ELL,
  TXTWCL_What_is_an_Instant_BonusX_How__ELL
} from './Description.messages.json';

export interface Props {
  prizeDetails: PrizeDetail;
  showFull?: boolean;
}

const minSpinValue = 10;

const Description: React.FC<Props> = ({ prizeDetails, showFull }) => {
  const site = useSelector(select.cms.getSiteId);
  const siteIT = site === Sites.ITA;

  switch (prizeDetails.prizeType) {
    case PrizeType.IB:
      return (
        <Translation
          {...(showFull
            ? TXTWCL_Carry_an_expiry_date_and_must__ELL
            : TXTWCL_What_is_an_Instant_BonusX_How__ELL)}
        />
      );
    case PrizeType.FSB:
      return (
        <>
          {siteIT ? (
            <Translation
              {...(showFull
                ? TXTWCL_Carry_an_expiry_date_and_all_s_ELL_1
                : TXTWCL_What_is_a_Free_Spins_BonusX_Ho_ELL)}
            />
          ) : (
            <Translation
              {...(showFull
                ? TXTWCL_Carry_an_expiry_date_and_all_s_ELL
                : TXTWCL_What_is_a_Free_Spins_BonusX_Ho_ELL)}
            />
          )}{' '}
          {showFull && (
            <Translation
              {...TXTWCL_Credited_Free_Spins_will_carry_ELL}
              values={{
                0: <CurrencyAmount value={minSpinValue} currency={prizeDetails.currency} />
              }}
            />
          )}
        </>
      );
    case PrizeType.CASH:
    default:
      return [Sites.ITA, Sites.POR].includes(site) ? (
        <Translation
          {...(showFull
            ? TXTWCL_Bonuses_may_not_be_withdrawnX__ELL
            : TXTWCL_What_is_a_Cash_BonusX_How_can__ELL)}
        />
      ) : (
        <Translation
          {...(showFull
            ? TXTWCL_Is_credited_to_your_Stars_Acco_ELL
            : TXTWCL_What_is_a_Cash_BonusX_How_can__ELL)}
        />
      );
  }
};

export default Description;
